import {
  CreateCustomerDataTypes,
  CustomerDataTypes,
  UpdateCustomerDataTypes
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllCustomerService = async (
  params?: BaseFilterParams,
): Promise<APIPaginationResponse<CustomerDataTypes[]>> => {
  const res = await axiosInstance.get('customers', { params });
  return res.data;
};

export const getCustomerService = async (
  id: string,
): Promise<CustomerDataTypes> => {
  const res = await axiosInstance.get(`customers/${id}`);
  return res.data.data;
};

export const createCustomerService = async (params: CreateCustomerDataTypes)
: Promise<void> => {
  await axiosInstance.post('customers', params);
};

export const updateCustomerService = async (params: UpdateCustomerDataTypes)
: Promise<void> => {
  await axiosInstance.put(`customers/${params.id}`, params);
};

export const deleteCustomerService = async (ids: number[]): Promise<void> => {
  await axiosInstance.delete('customers', { data: { ids } });
};
